<template>
    <ErrorDialog
        :show="show"
        title="Ticket Respond Error"
        @close-error-dialog="close"
    >
        <template v-slot:errorMessage>
            <div class="py-4">
                {{ respondedToText }}
            </div>
            <div v-if="errorResults.length > 0">
                <ul>
                    <li 
                        v-for="(errorMessage, index) of errorMessages"
                        :key="index"
                    >
                        {{ errorMessage }}
                    </li>
                </ul>
            </div>
        </template>
    </ErrorDialog>
</template>
<script>
import ErrorDialog from './ErrorDialog.vue';
export default {
    components: {
        ErrorDialog,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        respondResult: {
            type: Object,
            default: () => ({}),
            required: true,
        }
    },
    computed: {
        results() {
            return Array.isArray(this.respondResult.tickets) ? this.respondResult.tickets : [];
        },
        resultCount() {
            return this.results.length;
        },
        errorResults() {
            return this.results.filter(result => {
                return result?.result?.result  === 'ERR';
            });
        },
        fallbackMessages() {
            const messages = [];
            if (typeof this.respondResult?.message === 'string' && this.respondResult.message.length) {
                messages.push(this.respondResult.message);
            }
            if (typeof this.respondResult?.error === 'string' && this.respondResult.error.length) {
                messages.push(this.respondResult.error);
            }
            return messages;
        },
        errorMessages() {
            let errorMessages = [];
            for(let error of this.errorResults) {
                if(!errorMessages.includes(error?.result?.message)) {
                    errorMessages.push(error?.result?.message);
                }
            }
            for (let message of this.fallbackMessages) {
                if (!errorMessages.includes(message)) {
                    errorMessages.push(message);
                }
            }
            return errorMessages;
        },
        respondedToText() {
            if (!this.resultCount) {
                return this.respondResult?.message || 'Ticket response failed.';
            }
            let succesCount = this.resultCount - this.errorResults.length;
            let failedCount = this.errorResults.length;
            return `${succesCount} of ${this.resultCount} ticket${this.resultCount > 1 ? 's' : ''} were responded to.`
               + `  ${failedCount} ticket${failedCount > 1 ? 's' : ''} failed to be responded to.`;
        }
    },
    methods: {
        close() {
            this.$emit('close-response-error-dialog');
        }
    }
};
</script>
